<p>{{ 'CPh3.1.p' | translate }}</p>

<h3 class="style-color">
  <span class="pdng-right">2</span>
  {{ 'CPh3.2' | translate }}
</h3>
<p>{{ 'CPh3.2.p' | translate }}</p>
<p>{{ 'CPh3.2.p1' | translate }}</p>
<p>{{ 'CPh3.2.p2' | translate }}</p>

<h3 class="style-color">
  <span class="pdng-right">3</span>
  {{ 'CPh3.3' | translate }}
</h3>
<p>
  {{ 'CPh3.3.p' | translate }}
  <a href="https://www.allaboutcookies.org" target="_blank" style="color: blue">https://www.allaboutcookies.org</a>
  {{ 'CPh3.3.p.1' | translate }}
</p>
<p>{{ 'CPh3.3.p1' | translate }}</p>

<h3 class="style-color">
  <span class="pdng-right">4</span>
  {{ 'CPh3.4' | translate }}
</h3>
<ul class="list-style style-color">
  <li>
    <span>4.1</span>
    <strong>{{ 'CPh3.4.l1' | translate }}</strong>
    <p>{{ 'CPh3.4.l1.p' | translate }}</p>
  </li>
  <li>
    <span>4.2</span>
    <strong>{{ 'CPh3.4.l2' | translate }}</strong>
    <p>{{ 'CPh3.4.l2.p' | translate }}</p>
    <ul class="style-circle">
      <li>{{ 'CPh3.4.l2.1' | translate }}</li>
    </ul>
  </li>
  <li>
    <span>4.3</span>
    <strong>{{ 'CPh3.4.l3' | translate }}</strong>
    <p>{{ 'CPh3.4.l3.p' | translate }}</p>
  </li>
  <li>
    <span>4.4</span>
    <strong>{{ 'CPh3.4.l4' | translate }}</strong>
    <p>{{ 'CPh3.4.l4.p' | translate }}</p>
    <ul class="style-circle">
      <li>{{ 'CPh3.4.l4.1' | translate }}</li>
      <li>
        {{ 'CPh3.4.l4.2' | translate }}
        <ul class="style-circle">
          <li>{{ 'CPh3.4.l4.2.1' | translate }}</li>
        </ul>
      </li>
    </ul>
  </li>
</ul>

<h3 class="style-color">
  <span class="pdng-right">5</span>
  {{ 'CPh3.5' | translate }}
</h3>
<p>{{ 'CPh3.5.p' | translate }}</p>

<h3 class="style-color">
  <span class="pdng-right">6</span>
  {{ 'CPh3.6' | translate }}
</h3>
<p>{{ 'CPh3.6.p' | translate }}</p>

<h3 class="style-color">
  <span class="pdng-right">7</span>
  {{ 'CPh3.7' | translate }}
</h3>
<p>{{ 'CPh3.7.p' | translate }}</p>
<p>{{ 'CPh3.7.p1' | translate }}</p>
